export default __webpack_public_path__ + "static/media/GRUPO_2_2026.00efaa10.pdf";